import React, { useState } from 'react';
import { Modal, Form, Input } from 'antd';

const DeleteModal = ({ showDeleteModal, modalVisibleFunc, onSave }: any) => {
    const [form] = Form.useForm();
    const handleOk = () => {
        console.log(form.getFieldValue('reason'), 'form');
        onSave(form.getFieldValue('reason'));
    };

    const handleCancel = () => {
        modalVisibleFunc(false);
    };
    return (
        <>
            <Modal title="Reason for deleting Invoice" visible={showDeleteModal} onOk={handleOk} onCancel={handleCancel}>
                <Form name="basic" form={form} initialValues={null} className="form">
                    <Form.Item name="reason">
                        <Input autoComplete="off" className="document-edit-block__input " placeholder={'reason'} />
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
}
export default DeleteModal;